import { CSS, StyleProps } from "@shared/primitive-components"

export const itemDetails = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(3),
  minHeight: `79px`,
  "@media (max-width: 1250px)": {
    marginBottom: props.theme.spacing(1),
    minHeight: `unset`,
    marginTop: props.theme.spacing(2),
  },
})

export const speedPercentages = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(4),
  alignItems: `baseline`,
})

export const marginRight = (props: StyleProps): CSS => ({
  marginRight: props.theme.spacing(3),
})

export const largeText = (props: StyleProps): CSS => ({
  ...props.theme.typography.headline1,
  marginRight: props.theme.spacing(2),
  minWidth: `60px`,
  textAlign: `right`,
})

export const listItemInner = (): CSS => ({
  flexDirection: `column`,
  justifyContent: `space-between`,
  height: `100%`,
  flex: `1 1 0px`,
})

export const listItem = (): CSS => ({
  listStyle: `none`,
  flex: `1 1 0px`,
  "&:last-child a": {
    borderRight: `1px solid transparent`,
  },
})

export const link = (props: StyleProps): CSS => ({
  textDecorationLine: `none`,
  color: `inherit`,
  marginRight: props.theme.spacing(6),
  paddingRight: props.theme.spacing(4),
  borderRight: `1px solid ${props.theme.palette.grey.light}`,
  display: `block`,
  height: `100%`,
  "@media (max-width: 1250px)": {
    marginRight: 0,
    paddingRight: 0,
    borderRight: 0,
    marginBottom: props.theme.spacing(2),
    borderBottom: `1px solid ${props.theme.palette.grey.light}`,
  },
})

export const tooltip = (): CSS => ({
  maxWidth: `200px`,
})

export const number = (props: StyleProps): CSS => ({
  ...props.theme.typography.headline1,
  width: `40px`,
  height: `40px`,
  display: `flex`,
  flexBasis: `40px`,
  flexGrow: 0,
  flexShrink: 0,
  justifyContent: `center`,
  alignItems: `center`,
  marginRight: props.theme.spacing(3),
  backgroundColor: props.theme.palette.brand,
})

export const vrn = (props: StyleProps): CSS => ({
  ...props.theme.typography.headline1,
  fontSize: `20px`,
  minWidth: `81px`,
  marginBottom: props.theme.spacing(1),
})

export const caption = (props: StyleProps): CSS => ({
  fontSize: props.theme.fontSize.caption,
  alignSelf: `flex-end`,
  lineHeight: `normal`,
})

export const rightIconWrap = (): CSS => ({
  alignSelf: `center`,
  "@media (max-width: 1250px)": {
    position: `absolute`,
    right: `36px`,
  },
})

export const blur = (): CSS => ({
  color: `transparent`,
  textShadow: `1px 1px 8px black`,
})
